<div *ngIf="eventDate">
  <h1>Countdown to Event</h1>
  <div>
    <span>{{ days }}d </span>
    <span>{{ hours }}h </span>
    <span>{{ minutes }}m </span>
    <span>{{ seconds }}s </span>
  </div>
</div>